module.exports = "<router-outlet>\r\n\r\n</router-outlet>\r\n\r\n\r\n<app-time-out>\r\n\r\n</app-time-out>\r\n"